var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('social-links');
import { breakpoints, theme } from '@shapeable/theme';
import { useLink } from '../hooks/use-link';
import { ThreadsFilledIconGlyph, FacebookFilledIconGlyph, LinkedinFilledIconGlyph, InstagramFilledIconGlyph, TikTokFilledIconGlyph, FlickrFilledIconGlyph, YouTubeFilledIconGlyph, XFilledIconGlyph } from '@shapeable/icons';
import { pickBy } from 'lodash';
import { useSocialLinks } from '../hooks/use-social-links';
import { useComponentProps } from '../context/component-props-context';
// -------- Types -------->
export var SocialLinksServiceOrderDefault = ['linkedin', 'threads', 'twitter', 'facebook', 'instagram', 'youtube', 'tiktok', 'flickr'];
export var SocialLinksDefaultProps = {
  baseSize: 32,
  tabletSize: 32,
  desktopSize: 32,
  spaceUnits: 2,
  urls: {},
  order: SocialLinksServiceOrderDefault,
  colors: {
    fill: 'button',
    hover: {
      fill: 'link-hover'
    }
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    a:last-child svg {\n      margin-right: 0;\n    }\n  "], ["\n    a:last-child svg {\n      margin-right: 0;\n    }\n  "])))
});
var IconStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var _color = _a._color,
      _hoverColor = _a._hoverColor,
      baseSize = _a.baseSize,
      spaceUnits = _a.spaceUnits;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      width: ", "px;\n      height: ", "px;\n      margin-right: ", ";\n      ", ";\n\n      &:hover {\n        ", ";\n      }\n\n    "], ["\n      width: ", "px;\n      height: ", "px;\n      margin-right: ", ";\n      ", ";\n\n      &:hover {\n        ", ";\n      }\n\n    "])), baseSize, baseSize, theme.UNIT(spaceUnits), theme.FILL(_color), theme.FILL(_hoverColor));
  }),
  tablet: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var tabletSize = _a.tabletSize;
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      width: ", "px;\n      height: ", "px;\n    "], ["\n      width: ", "px;\n      height: ", "px;\n    "])), tabletSize, tabletSize);
  }),
  desktop: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var desktopSize = _a.desktopSize;
    return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      width: ", "px;\n      height: ", "px;\n    "], ["\n      width: ", "px;\n      height: ", "px;\n    "])), desktopSize, desktopSize);
  })
});
var ThreadsIconStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), IconStyles)
});
var TwitterIconStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), IconStyles)
});
var FacebookIconStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), IconStyles)
});
var LinkedinIconStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), IconStyles)
});
var InstagramIconStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), IconStyles)
});
var TikTokIconStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), IconStyles)
});
var YouTubeIconStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), IconStyles)
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  TwitterIcon: styled(XFilledIconGlyph)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), TwitterIconStyles),
  ThreadsIcon: styled(ThreadsFilledIconGlyph)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), ThreadsIconStyles),
  FacebookIcon: styled(FacebookFilledIconGlyph)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), FacebookIconStyles),
  LinkedinIcon: styled(LinkedinFilledIconGlyph)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), LinkedinIconStyles),
  InstagramIcon: styled(InstagramFilledIconGlyph)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), InstagramIconStyles),
  TikTokIcon: styled(TikTokFilledIconGlyph)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), TikTokIconStyles),
  FlickrIcon: styled(FlickrFilledIconGlyph)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), FacebookIconStyles),
  YouTubeIcon: styled(YouTubeFilledIconGlyph)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), YouTubeIconStyles)
};
export var SocialLinks = function (props) {
  var _a = useComponentProps('SocialLinks', SocialLinksDefaultProps, props),
    className = _a.className,
    baseSize = _a.baseSize,
    tabletSize = _a.tabletSize,
    desktopSize = _a.desktopSize,
    spaceUnits = _a.spaceUnits,
    order = _a.order,
    urls = _a.urls,
    colors = _a.colors;
  var _b = useSocialLinks(urls),
    twitter = _b.twitter,
    threads = _b.threads,
    facebook = _b.facebook,
    linkedin = _b.linkedin,
    instagram = _b.instagram,
    flickr = _b.flickr,
    tiktok = _b.tiktok,
    youtube = _b.youtube;
  var Link = useLink().Link;
  var iconProps = {
    _hoverColor: colors.hover.fill,
    baseSize: baseSize,
    tabletSize: tabletSize,
    desktopSize: desktopSize,
    _color: colors.fill,
    spaceUnits: spaceUnits
  };
  var serviceMap = pickBy({
    linkedin: linkedin && React.createElement(Link, {
      key: "linkedin",
      target: "_blank",
      href: linkedin
    }, React.createElement(My.LinkedinIcon, __assign({}, iconProps))),
    twitter: twitter && React.createElement(Link, {
      key: "twitter",
      target: "_blank",
      href: twitter
    }, React.createElement(My.TwitterIcon, __assign({}, iconProps))),
    threads: threads && React.createElement(Link, {
      key: "threads",
      target: "_blank",
      href: threads
    }, React.createElement(My.ThreadsIcon, __assign({}, iconProps))),
    youtube: youtube && React.createElement(Link, {
      key: "youtube",
      target: "_blank",
      href: youtube
    }, React.createElement(My.YouTubeIcon, __assign({}, iconProps))),
    facebook: facebook && React.createElement(Link, {
      key: "facebook",
      target: "_blank",
      href: facebook
    }, React.createElement(My.FacebookIcon, __assign({}, iconProps))),
    instagram: instagram && React.createElement(Link, {
      key: "instagram",
      target: "_blank",
      href: instagram
    }, React.createElement(My.InstagramIcon, __assign({}, iconProps))),
    tiktok: tiktok && React.createElement(Link, {
      key: "tiktok",
      target: "_blank",
      href: tiktok
    }, React.createElement(My.TikTokIcon, __assign({}, iconProps))),
    flickr: flickr && React.createElement(Link, {
      key: "flickr",
      target: "_blank",
      href: flickr
    }, React.createElement(My.FlickrIcon, __assign({}, iconProps)))
  });
  var hasAny = !!(linkedin || twitter || threads || facebook || instagram || youtube || tiktok || flickr);
  if (!hasAny) return null;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, order.map(function (service) {
    return serviceMap[service];
  }));
};
// SocialLinks.defaultProps = SocialLinksDefaultProps;
SocialLinks.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23;